import {icon} from '@salesforce/retail-react-app/app/components/icons';

// Import SVG assets to register them in the sprite sheet
import '@amblique/king-living/app/assets/svg/arrow-right.svg';
import '@amblique/king-living/app/assets/svg/hotspot-content-arrow.svg';
import '@amblique/king-living/app/assets/svg/social-facebook.svg';
import '@amblique/king-living/app/assets/svg/social-instagram.svg';
import '@amblique/king-living/app/assets/svg/social-wechat.svg';
import '@amblique/king-living/app/assets/svg/social-youtube.svg';
import '@amblique/king-living/app/assets/svg/social-linkedin.svg';
import '@amblique/king-living/app/assets/svg/location-pin.svg';
import '@amblique/king-living/app/assets/svg/check.svg';
import '@amblique/king-living/app/assets/svg/shop.svg';
import '@amblique/king-living/app/assets/svg/plus.svg';
import '@amblique/king-living/app/assets/svg/minus.svg';
import '@amblique/king-living/app/assets/svg/cube.svg';
import '@amblique/king-living/app/assets/svg/shipping-box.svg';
import '@amblique/king-living/app/assets/svg/warranty.svg';
import '@amblique/king-living/app/assets/svg/home.svg';
import '@amblique/king-living/app/assets/svg/light-bulb.svg';
import '@amblique/king-living/app/assets/svg/plus-circle.svg';
import '@amblique/king-living/app/assets/svg/gallery-arrow-left.svg';
import '@amblique/king-living/app/assets/svg/gallery-arrow-right.svg';
import '@amblique/king-living/app/assets/svg/gallery-pause.svg';
import '@amblique/king-living/app/assets/svg/gallery-play.svg';
import '@amblique/king-living/app/assets/svg/icon-cool.svg';
import '@amblique/king-living/app/assets/svg/icon-warm.svg';
import '@amblique/king-living/app/assets/svg/icon-air.svg';
import '@amblique/king-living/app/assets/svg/icon-cover.svg';
import '@amblique/king-living/app/assets/svg/icon-showrooms-online.svg';
import '@amblique/king-living/app/assets/svg/icon-online-exclusive.svg';
import '@amblique/king-living/app/assets/svg/size-circle.svg';
import '@amblique/king-living/app/assets/svg/instagram.svg';
import '@amblique/king-living/app/assets/svg/bookmark.svg';
import '@amblique/king-living/app/assets/svg/tune.svg';
import '@amblique/king-living/app/assets/svg/arrow-down.svg';
import '@amblique/king-living/app/assets/svg/close-filter.svg';
import '@amblique/king-living/app/assets/svg/magnifying-search.svg';
import '@amblique/king-living/app/assets/svg/check-circle.svg';
import '@amblique/king-living/app/assets/svg/close-modal.svg';
import '@amblique/king-living/app/assets/svg/search-icon.svg';
import '@amblique/king-living/app/assets/svg/submit-search.svg';
import '@amblique/king-living/app/assets/svg/union.svg';
import '@amblique/king-living/app/assets/svg/checkbox-tick.svg';
import '@amblique/king-living/app/assets/svg/alert-error.svg';
import '@amblique/king-living/app/assets/svg/alert-warning.svg';
import '@amblique/king-living/app/assets/svg/alert-info.svg';
import '@amblique/king-living/app/assets/svg/alert-success.svg';
import '@amblique/king-living/app/assets/svg/upload.svg';
import '@amblique/king-living/app/assets/svg/cart.svg';
import '@amblique/king-living/app/assets/svg/search.svg';
import '@amblique/king-living/app/assets/svg/location.svg';
import '@amblique/king-living/app/assets/svg/profile.svg';
import '@amblique/king-living/app/assets/svg/global.svg';
import '@amblique/king-living/app/assets/svg/close.svg';
import '@amblique/king-living/app/assets/svg/sandwich.svg';
import '@amblique/king-living/app/assets/svg/burger.svg';
import '@amblique/king-living/app/assets/svg/icons-flag.svg';
import '@amblique/king-living/app/assets/svg/icon-location.svg';
import '@amblique/king-living/app/assets/svg/icon-location-detail.svg';
import '@amblique/king-living/app/assets/svg/icon-phone.svg';
import '@amblique/king-living/app/assets/svg/icon-email.svg';
import '@amblique/king-living/app/assets/svg/quote.svg';

// Export icon components using the icon factory
export const BrandLogo = icon('brand-logo', {viewBox: '0 0 112 24'});
export const ArrowRightIcon = icon('arrow-right');
export const HotspotContentArrowIcon = icon('hotspot-content-arrow');
export const SocialFacebookIcon = icon('social-facebook');
export const SocialInstagramIcon = icon('social-instagram');
export const SocialWechatIcon = icon('social-wechat');
export const SocialYoutubeIcon = icon('social-youtube');
export const SocialLinkedinIcon = icon('social-linkedin');
export const LocationPinIcon = icon('location-pin');
export const CheckIcon = icon('check');
export const ShopIcon = icon('shop');
export const PlusIcon = icon('plus');
export const MinusIcon = icon('minus');
export const CubeIcon = icon('cube');
export const ShippingBoxIcon = icon('shipping-box');
export const WarrantyIcon = icon('warranty');
export const HomeIcon = icon('home');
export const LightBulbIcon = icon('light-bulb');
export const PlusCircleIcon = icon('plus-circle');
export const GalleryArrowLeftIcon = icon('gallery-arrow-left');
export const GalleryArrowRightIcon = icon('gallery-arrow-right');
export const GalleryPauseIcon = icon('gallery-pause');
export const GalleryPlayIcon = icon('gallery-play');
export const IconCool = icon('icon-cool');
export const IconWarm = icon('icon-warm');
export const IconAir = icon('icon-air');
export const IconCover = icon('icon-cover');
export const IconShowroomsOnline = icon('icon-showrooms-online');
export const IconOnlineExclusive = icon('icon-online-exclusive');
export const SizeCircle = icon('size-circle');
export const InstagramIcon = icon('instagram');
export const BookmarkIcon = icon('bookmark');
export const TuneIcon = icon('tune');
export const ArrowDownIcon = icon('arrow-down');
export const CloseFilterIcon = icon('close-filter');
export const MagnifyingSearchIcon = icon('magnifying-search');
export const CheckCircleIcon = icon('check-circle');
export const CloseModalIcon = icon('close-modal');
export const SearchIcon = icon('search-icon');
export const SubmitSearchIcon = icon('submit-search');
export const UnionIcon = icon('union');
export const CheckboxTickIcon = icon('checkbox-tick', {viewBox: '0 0 16 12'});
export const AlertErrorIcon = icon('alert-error');
export const AlertWarningIcon = icon('alert-warning');
export const AlertInfoIcon = icon('alert-info');
export const AlertSuccessIcon = icon('alert-success');
export const UploadIcon = icon('upload');
export const CartIcon = icon('cart');
export const SearchSimpleIcon = icon('search');
export const LocationSimpleIcon = icon('location');
export const ProfileIcon = icon('profile');
export const GlobalIcon = icon('global');
export const CloseIcon = icon('close');
export const SandwichIcon = icon('sandwich');
export const BurgerIcon = icon('burger');
export const FlagIcon = icon('icons-flag');
export const MyLocationIcon = icon('icon-location');
export const LocationDetailIcon = icon('icon-location-detail');
export const PhoneIcon = icon('icon-phone');
export const EmailIcon = icon('icon-email');
export const QuoteIcon = icon('quote');
export * from '@salesforce/retail-react-app/app/components/icons';
